import { FaFolder } from "react-icons/fa";
import { getFileIcon } from "utils";
import { FileSystemItem } from "types";
import { useLibraryContext } from "../../context/LibraryContext";

const FileSystemCard = ({ item }: { item: FileSystemItem }) => {
  const { setCurrentFolderId, setBreadcrumb } = useLibraryContext();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setCurrentFolderId(item.id);
    setBreadcrumb([
      { id: item.id, name: item.name, typeName: item?.typeName ?? null },
    ]);
  };

  return (
    <div className="relative">
      <button
        onClick={handleClick}
        className="flex w-full items-center gap-3 rounded-lg border border-gray-200 p-4 hover:bg-gray-50 dark:border-navy-700 dark:hover:bg-navy-700"
      >
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100 dark:bg-navy-800">
          {item.type === "Folder" ? (
            <FaFolder className="text-2xl text-yellow-500" />
          ) : (
            getFileIcon(item.name)
          )}
        </div>
        <div className="flex flex-col">
          <span className="font-medium text-navy-700 dark:text-white">
            {item.name}
          </span>
          <span className="mr-auto text-sm text-gray-500 dark:text-gray-400">
            {item.type === "Folder"
              ? "Folder"
              : item.name.split(".").pop()?.toUpperCase()}
          </span>
        </div>
      </button>
    </div>
  );
};

export default FileSystemCard;
